<template>
    <div>
        <BaseButton
            class="text-theme-icon"
            dusk="MoreActionsHeader"
            :tooltip="localizations[lang].tooltips.moreActions"
            icon="baseline-more_vert-24px"
            aria-haspopup="menu"
            :aria-expanded="isMenuVisible"
            @click="toggleMenu"
        />
        <AdaptiveListDropdown :is-open="isMenuVisible" @close="toggleRightSubmenu">
            <ListItemButton
                v-if="isAudiobook"
                v-tooltip="localizations[lang].tooltips.about"
                dusk="aboutAudiobook"
                icon-name="outline-info-24px"
                width="24px"
                height="24px"
                @click="toggleAudiobookAbout"
            >
                <span>{{ localizations[lang].tooltips.about }}</span>
            </ListItemButton>
            <ListItemButton
                dusk="readerTour"
                icon-name="outline-info-24px"
                width="24px"
                height="24px"
                @click="showReaderTour"
            >
                <span>{{ localizations[lang].onboarding.readerTour }}</span>
            </ListItemButton>
            <ListItemButton
                v-if="canEditAddOns"
                dusk="addOnsTour"
                icon-name="squares-plus-24px"
                width="24px"
                height="24px"
                @click="showAddOnsTour"
            >
                <span>{{ addOnsTourLabel }}</span>
            </ListItemButton>
            <ListItemButton
                v-if="isPrintControlEnabled"
                dusk="printControl"
                icon-name="baseline-print-24px"
                width="24px"
                height="24px"
                :aria-label="localizations[lang].print.menuLabel"
                @click="openPrintControl"
            >
                <span>{{ localizations[lang].print.menuLabel }}</span>
            </ListItemButton>
            <ReaderPromoteAppButton />
            <ComponentListsButton />
            <BookCitationMenu />
            <SocialShareButton v-if="isShareEnabled" />
            <DebugMenuSection v-if="isDevMode" />
        </AdaptiveListDropdown>
    </div>
</template>

<script>
import ComponentListsButton from './ComponentListsButton.vue';
import AdaptiveListDropdown from './list/AdaptiveListDropdown.vue';
import ReaderPromoteAppButton from '../ReaderPromoteApp/ReaderPromoteAppButton.vue';
import BaseButton from './buttons/BaseButton.vue';
import SocialShareButton from '../SocialShare/SocialShareButton.vue';
import BookCitationMenu from './BookCitationMenu.vue';
import DebugMenuSection from './DebugMenuSection.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import ListItemButton from './list/ListItemButton.vue';
import { tourStrings } from '../../../src/js/tours/tourStrings';

export default {
    components: {
        ListItemButton,
        ReaderPromoteAppButton,
        ComponentListsButton,
        AdaptiveListDropdown,
        SocialShareButton,
        BookCitationMenu,
        BaseButton,
        DebugMenuSection,
    },
    props: {
        isMenuVisible: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
        ...mapGetters(['onlyMobileVisible', 'isShareEnabled', 'isAudiobook', 'isPrintControlEnabled', 'canEditAddOns']),
        addOnsTourLabel() {
            return tourStrings(this.localizations, this.lang).addOnsEditor?.replay ?? '';
        },
        isDevMode() {
            // Local shows every dev knob; staging shows the safe subset (the
            // DebugMenuSection filters it). Never enabled in production.
            return ['local', 'staging'].includes(process.env.VITE_ENV);
        },
    },
    methods: {
        ...mapMutations(['toggleAudiobookAbout', 'openOnboarding', 'closeTourBanner']),
        ...mapActions(['toggleRightSubmenu', 'openPrintControl', 'startTour']),
        toggleMenu() {
            this.$emit('toggle', !this.isMenuVisible);
        },
        showReaderTour() {
            this.toggleRightSubmenu();
            this.closeTourBanner();
            this.openOnboarding();
        },
        showAddOnsTour() {
            this.toggleRightSubmenu();
            this.startTour('addons-editor');
        },
    },
};
</script>
